import { ChangeWorkingDaysStore, NewWorkingDaysStore, WorkingDaysStore } from './working-days-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new WorkingDaysStore());
  storeBuilder.addRepository(new ChangeWorkingDaysStore());
  storeBuilder.addRepository(new NewWorkingDaysStore());
}
